import React from "react";
import ReactDOM from "react-dom/client";
import * as Sentry from "@sentry/react";
import "@/index.css";
import App from "@/App";

const sentryDsn = process.env.REACT_APP_SENTRY_DSN?.trim();
const tracesSampleRateRaw = process.env.REACT_APP_SENTRY_TRACES_SAMPLE_RATE ?? "0.1";
const tracesSampleRate = Number.parseFloat(tracesSampleRateRaw);

if (sentryDsn) {
  Sentry.init({
    dsn: sentryDsn,
    environment: process.env.REACT_APP_SENTRY_ENVIRONMENT || process.env.NODE_ENV || "development",
    tracesSampleRate: Number.isFinite(tracesSampleRate) ? tracesSampleRate : 0.1,
  });
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
